import { Component, Injector } from '@angular/core';
import { AreaService, ZoneService } from '../../ve.service';
import { BaseGridComponent } from '../base-grid/base-grid.component';
import { CgpConfirmationDialogService } from '../../../../shared/cgp-confirmation-dialog/cgp-confirmation-dialog.service';
import { CgpSnackbarService } from '../../../../shared/cgp-snackbar/cgp-snackbar.service';
import { Validators } from '@angular/forms';
import { FilterableService } from '../../../../shared/filterable-service';

@Component({
  selector: 'app-areas',
  templateUrl: '../base-grid/base-grid.component.html',
})
export class AreasComponent  extends BaseGridComponent {
  public descMaxLength: number = null;
  private readonly zoneService: ZoneService;
  private readonly zoneFilterableService = new FilterableService();

  constructor(
    cgpConfirmationDialogService: CgpConfirmationDialogService,
    cgpSnackbarService: CgpSnackbarService,
    service: AreaService,
    injector: Injector,
  ) {
    super(cgpConfirmationDialogService, cgpSnackbarService, service, injector);
    this.zoneService = injector.get(ZoneService);
    this.descMaxLength = 20;
    this.appCardTitle = 'Areas';
    this.path = '/?activeOnly=false';

    this.columns = [
      {
        field: 'Description',
        title: 'Area',
      },
      {
        field: 'ZoneNames',
        title: 'Zones',
        type: 'multiselect',
        service: this.zoneFilterableService,
        textField: 'Description',
        valueField: 'Id',
        name: 'ZoneIds',
        refreshSecondaryData: this.populateZonesList,
      },
      {
        field: 'IsActive',
        title: 'Active',
        editor: 'boolean',
        filter: 'boolean'
      },
    ];

    this.editForm = this.formBuilder.group({
      Id: [],
      Description: ['', Validators.required],
      ZoneNames: [],
      ZoneIds: [],
      IsActive: [],
      AuditDto: []
    });
  }

  populateZonesList(dataItem: any) {
    dataItem.zoneService.read()
    .then(result => {
      if (result.length > 0) {
        result.sort((a, b) => a.Description.localeCompare(b.Description));
      }
      dataItem.zoneFilterableService.next(result);
    });
  }
}
